import { Box, Flex, Select } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import ContentBox from "components/elements/ContentBox";
import DocumentsTable from "components/elements/DocumentsTable";
import UploadDocuments from "pages/Documents/elements/UploadDocuments";
import { ChecklistContext } from "providers/checklist";
import { LoanContext } from "providers/loan";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";
import { apiRequest } from "utils/api";
import { getUniqueValuesByKey } from "utils/helpers";
import { permissionConstants, hasPermission } from "utils/permissionHelper";

const DocumentsTab = () => {
  const { loan } = useContext(LoanContext);
  const { user } = useTenant();
  const { items } = useContext(ChecklistContext);
  const [filteredDocuments, setFilteredDocuments] = useState<any[]>([]);

  const {
    data: documents,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "documents-for-loan-list",
      {
        loanId: loan?.id,
      },
    ],
    queryFn: () =>
      apiRequest("/supabase/documents/select", {
        loanId: loan?.id,
      }),
    enabled: hasPermission(user, permissionConstants.viewAllDocuments) && !!loan?.id,
    select: data => data.documents ?? [],
  });

  useEffect(() => {
    refetch();
  }, [loan, refetch]);

  useEffect(() => {
    setFilteredDocuments(documents);
  }, [documents]);

  function getCategories() {
    const categories = getUniqueValuesByKey(items, "category");
    categories.push("Loan Application");
    return categories.sort();
  }

  function handleCategoryChange(value: string) {
    if (!value) {
      setFilteredDocuments(documents);
      return;
    }

    setFilteredDocuments(
      documents.filter((doc: any) => {
        const associatedItem = items.find((item: any) => item.id === doc.loan_item);

        return doc.category === value || associatedItem?.category === value;
      })
    );
  }

  return (
    <ContentBox>
      <Box mb="20px">
        <Flex justifyContent="space-between">
          <Box>
            <Select
              placeholder="All Categories"
              color="gray.200"
              isDisabled={getUniqueValuesByKey(items, "category").length === 0}
              onChange={ev => handleCategoryChange(ev.target.value)}
            >
              {getCategories().map(category => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </Select>
          </Box>
          <Box>
            <UploadDocuments
              defaultLoan={{
                label: loan!.name,
                value: loan!.id,
              }}
            />
          </Box>
        </Flex>
      </Box>
      <DocumentsTable
        isLoading={isLoading}
        documents={filteredDocuments}
        items={items}
        columns={["Name", "Type", "Uploader", "Status", "Uploaded", "Category"]}
      />
    </ContentBox>
  );
};

export default DocumentsTab;
